// extracted by mini-css-extract-plugin
export default {"statsContainer":"StatsPanel_statsContainer__6hAuj","statsItem":"StatsPanel_statsItem__AZA2t"};